import { FeedbackState } from './types';

export const initialState: FeedbackState = {
    isShowCreateFeedbackRequest: false,
};
